import { Redirect, Route, Switch } from 'react-router-dom'
import withData, { IWithDataProps } from '@cbgms/base/http/WithData'
import AccountSettings from 'app-support/AccountSettings'
import BankHolidays from 'app-support/bankholidays/components/Container'
import CacheContainer from 'app-support/cache/components/Container'
import DeveloperSettingsContainer from 'app-support/developer-settings/Container'
import CompaniesContainer from 'app-support/company/components/Container'
import ConceptsContainer from 'app-support/concepts/components/Container'
import { DispatchProp } from 'react-redux'
import EditExternalSystemForm from 'app-support/shops/components/ExternalSystems/Edit'
import EmployeesContainer from 'app-support/employees/components/Container'
import ExternalApplicationStatisticsContainer from 'app-support/external-application-statistics/components/Container'
import ExternalGMS from 'app-support/external-gms/components/Container'
import Header from 'app-support/Header/Header'
import LicensesRoutes from 'app-support/licenses/LicensesRoutes'
import LoggedInHome from 'app-support/LoggedInHome'
import MenuContainer from 'app-support/Container'
import MessagesContainer from 'app-support/messages/components/Container'
import NewExternalSystemForm from 'app-support/shops/components/ExternalSystems/New'
import {
  MODULE_MANAGEMENT_FLAG_MANAGEMENT,
  PERMISSION_ADMIN_UI_CONFIG,
  PERMISSION_APP_ACCESS,
  PERMISSION_CUSTOMER_ALERTS,
  PERMISSION_CUSTOMER_EMAIL_ATTACHMENT,
  PERMISSION_CUSTOMER_EMAIL_CONTENT,
  PERMISSION_CUSTOMER_OFFER,
  PERMISSION_CUSTOMER_PENDING_EMAIL,
  PERMISSION_CUSTOMER_PROFILE,
  PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU,
  PERMISSION_MANAGE_EXTERNAL_SYSTEMS,
  PERMISSION_MANAGE_SHOP_EMPLOYEES,
  PERMISSION_NEW_CUSTOMERT_ACQUISITION,
  PERMISSION_TELESALES
} from 'app-support/permissions/Permissions'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import ProductGroupRoutes from 'routes/productgroup/Routes'
import React from 'react'
import Regions from 'app-support/regions/components/Container'
import ReleaseNotesContainer from 'app-support/releasenotes/components/Container'
import Route401 from './errorroutes/401'
import Route404 from './errorroutes/404'
import ShopsContainer from 'app-support/shops/components/Container'
import StatsContainer from 'app-support/stats/components/Container'
import TelesalesContainer from 'app-support/telesales/components/Container'
import ThemeContainer from 'app-support/themes/components/Container'
import TranslationsContainer from 'app-support/translations/components/Container'
import TroubleShootContainer from 'app-support/troubleshoot/components/Container'
import WholesaleRoutes from 'routes/wholesale/Routes'
import WarrantyRoutes from 'routes/warranty/Routes'
import WholesaleFormRoutes from 'routes/wholesaler_forms/Routes'
import { loadEnums } from 'enums/state/actions'
import TroubleshootRoutes from 'app-support/troubleshoot/TroubleshootRoutes'
import routeNames from './routeNames'
import { Box } from '@mui/material'
import ConversionContainer from 'app-support/conversion/components/Container'
import { Layout } from 'app-support/road-assistance/components/Layout'
import Profile from 'app-support/LKQAdmin/Profile/Profile'
import ManageCustomerAccess from 'app-support/LKQAdmin/ManageCustomerAccess/ManageCustomerAccess'
import ProfileTabs from 'app-support/LKQAdmin/OfferPackage/components/ProfileTabs'
import Details from 'app-support/LKQAdmin/Profile/Details'
import CustomersList from 'app-support/LKQAdmin/OfferPackage/components/Customers/List'
import ConceptManagement from 'app-support/LKQAdmin/ConceptManegement/ConceptManegement'
import EmailContent from 'app-support/LKQAdmin/EmailContent/EmailContent'
import PendingEmailList from 'app-support/LKQAdmin/PendingEmailList/PendingEmailList'
import EmailAttachment from 'app-support/LKQAdmin/EmailAttachment/container/EmailAttachment'
import SalesGroupsList from 'app-support/LKQAdmin/SalesGroups/SalesGroupsList'
import CustomerAlerts from 'app-support/LKQAdmin/CustomerAlerts/components/CustomerAlerts'
import ConceptConfigurationContainer from './conceptConfiguration/Routes'
import XMLUpload from 'app-support/LKQAdmin/Settings/XMLUpload'

const loader = async (_props: never, { dispatch }: DispatchProp) => {
  await dispatch(loadEnums())
}

const RoadAssistanceContainer = React.lazy(() => import('./roadAssistance/Routes'))

const ProtectedRoutes: React.FC<IWithDataProps<void>> = () => {
  return (
    <MenuContainer>
      <Header />
      <Layout>
        <Box sx={{ p: 1 }}>
          <Switch>
            <PermissionRoute
              permission={PERMISSION_MANAGE_SHOP_EMPLOYEES}
              path={routeNames.employeesRoute}
              component={EmployeesContainer}
            />
            <PermissionRoute
              permission={PERMISSION_MANAGE_EXTERNAL_SYSTEMS}
              path={routeNames.externalSystemsRouteNew}
              component={NewExternalSystemForm}
            />
            <PermissionRoute
              permission={PERMISSION_MANAGE_EXTERNAL_SYSTEMS}
              path={routeNames.externalSystemsRouteEdit}
              component={EditExternalSystemForm}
            />
            <Redirect path={routeNames.externalSystemsRoute} to={routeNames.externalSystemsRouteFallback} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.companiesRoute} component={CompaniesContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.cacheRoute} component={CacheContainer} />
            <PermissionRoute
              permission={PERMISSION_APP_ACCESS}
              path={routeNames.developerSettingsDashboardRoute}
              component={DeveloperSettingsContainer}
            />
            <PermissionRoute
              permission={PERMISSION_APP_ACCESS}
              path={routeNames.externalApplicationStaticsRoute}
              component={ExternalApplicationStatisticsContainer}
            />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.messagesRoute} component={MessagesContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.productGroupRoute} component={ProductGroupRoutes} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.releaseNotesRoute} component={ReleaseNotesContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.shopsRoute} component={ShopsContainer} />
            <PermissionRoute permission={PERMISSION_TELESALES} path={routeNames.telesalesRoute} component={TelesalesContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.themesRoute} component={ThemeContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.translationsRoute} component={TranslationsContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.wholesaleRoute} component={WholesaleRoutes} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.warrantyRoute} component={WarrantyRoutes} />
            <PermissionRoute
              permission={PERMISSION_APP_ACCESS}
              path={routeNames.wholesaleFormRouteListPage}
              component={WholesaleFormRoutes}
            />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.conceptsRoute} component={ConceptsContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.statsRoute} component={StatsContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.bankHolidaysRoute} component={BankHolidays} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.regionsRoute} component={Regions} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.externalGMSRoute} component={ExternalGMS} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.licensesRoute} component={LicensesRoutes} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.troubleshootRoute} component={TroubleshootRoutes} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.accountancyRoute} component={TroubleShootContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.conversionRoute} component={ConversionContainer} />
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.roadAssistance} component={RoadAssistanceContainer} />
            <PermissionRoute
              permission={PERMISSION_APP_ACCESS}
              path={routeNames.conceptConfiguration}
              component={ConceptConfigurationContainer}
            />
            <Route path={routeNames.notAuthorizedRoute} component={Route401} />
            <Route path={routeNames.notFoundRoute} component={Route404} />
            <Route path={routeNames.accountSettingsRoute} component={AccountSettings} />
            {/* LKQAdmin routes */}
            <PermissionRoute
              permission={PERMISSION_NEW_CUSTOMERT_ACQUISITION}
              path='/LKQ/OfferPackage/:customerId'
              exact
              component={ProfileTabs}
            />
            <PermissionRoute
              permission={PERMISSION_NEW_CUSTOMERT_ACQUISITION}
              path='/LKQ/OfferPackage/:formsubmitted?/:isFormSuccess?'
              exact
              component={CustomersList}
            />
            <PermissionRoute permission={PERMISSION_CUSTOMER_PROFILE} path='/LKQ/Profile' exact component={Profile} />
            <PermissionRoute
              permission={PERMISSION_CUSTOMER_EMAIL_ATTACHMENT}
              path='/LKQ/EmailAttachment'
              exact
              component={EmailAttachment}
            />
            <PermissionRoute permission={PERMISSION_CUSTOMER_ALERTS} path='/LKQ/Alerts' exact component={CustomerAlerts} />
            <PermissionRoute
              permission={PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU}
              path='/LKQ/Profile/Details'
              exact
              component={Details}
            />
            <PermissionRoute
              permission={MODULE_MANAGEMENT_FLAG_MANAGEMENT}
              path='/LKQ/ManageCustomerAccess'
              exact
              component={ManageCustomerAccess}
            />
            <PermissionRoute permission={PERMISSION_NEW_CUSTOMERT_ACQUISITION} path='/LKQ/OfferPackage' exact component={CustomersList} />
            <PermissionRoute
              permission={PERMISSION_NEW_CUSTOMERT_ACQUISITION}
              path='/LKQ/Profile/ConceptManagement'
              exact
              component={ConceptManagement}
            />
            <PermissionRoute permission={PERMISSION_CUSTOMER_EMAIL_CONTENT} path='/LKQ/EmailContent' exact component={EmailContent} />
            <PermissionRoute
              permission={PERMISSION_CUSTOMER_PENDING_EMAIL}
              path='/LKQ/PendingEmailList'
              exact
              component={PendingEmailList}
            />
            <PermissionRoute permission={PERMISSION_CUSTOMER_OFFER} path='/LKQ/SalesGroups' exact component={SalesGroupsList} />
            <PermissionRoute permission={PERMISSION_ADMIN_UI_CONFIG} path='/LKQ/Settings' exact component={XMLUpload} />
            {/* End of LKQAdmin routes */}
            <PermissionRoute permission={PERMISSION_APP_ACCESS} path={routeNames.homeRoute} component={LoggedInHome} />
            <Redirect to='404' />
          </Switch>
        </Box>
      </Layout>
    </MenuContainer>
  )
}

ProtectedRoutes.displayName = 'ProtectedRoutes'

export default withData(loader)(ProtectedRoutes)
